// /lib/resolveThumbnail.ts
// ✅ FIXED: No more unnecessary proxying of public URLs + CORS-safe placeholder

export function resolveThumbnail(item: any): string {
  let rawUrl: string | null = null;
  
  // ✅ Uploaded videos (Supabase `uploads` table)
  if (item.thumbnail_url) {
    rawUrl = item.thumbnail_url;
  }
  
  // ✅ Drafts (Supabase `drafts` table)  
  if (!rawUrl && (item.customThumbnail || item.customthumbnail)) {
    rawUrl = item.customThumbnail || item.customthumbnail;
  }
  
  // ✅ YouTube fallback (if videoId exists)
  if (!rawUrl && item.youtube_video_id) {
    return `https://i.ytimg.com/vi/${item.youtube_video_id}/hqdefault.jpg`;
  }
  
  // ✅ CORS-safe default placeholder (inline SVG as data URL)
  if (!rawUrl) {
    return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjQwIiBoZWlnaHQ9IjM2MCIgdmlld0JveD0iMCAwIDY0MCAzNjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxyZWN0IHdpZHRoPSI2NDAiIGhlaWdodD0iMzYwIiBmaWxsPSIjZjNmNGY2Ii8+Cjx0ZXh0IHg9IjMyMCIgeT0iMTgwIiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjOWNhM2FmIiBmb250LXNpemU9IjE4Ij5ObyBUaHVtYm5haWw8L3RleHQ+Cjwvc3ZnPgo=";
  }
  
  // ✅ FIXED: Return all HTTP URLs directly (no proxying needed!)
  if (rawUrl.startsWith("http")) {
    return rawUrl; // ✅ All public URLs work directly
  }
  
  return rawUrl;
}